import { Button } from '@/components/ui/button';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import React from 'react';
import ComputerIcon from '/public/computer.svg';

interface IDmLoadingBtnProps {
  text: string | string[];
  onClick?: () => void;
}

export const DmLoadingBtn = React.memo((props: IDmLoadingBtnProps) => {
  const { text, onClick } = props;
  const [currentText, setCurrentText] = useState('');
  useEffect(() => {
    let timer: NodeJS.Timeout;
    let index = 0;
    if (Array.isArray(text)) {
      const _texts = text;
      setCurrentText(_texts[index % _texts.length]);
      timer = setInterval(() => {
        ++index;
        setCurrentText(_texts[index % _texts.length]);
      }, 4000);
    } else {
      setCurrentText(text);
    }

    return () => {
      clearInterval(timer);
    };
  }, [text]);
  return (
    <Button
      className={cn(
        'flex items-center justify-center py-2 px-3 mb-3 rounded-full text-[#8F8FEB] bg-[#EAEAFB] hover:text-[#8F8FEB] hover:bg-[#EAEAFB] h-auto max-w-full whitespace-normal shadow-[0px_2px_10px_2px_rgba(113,113,238,0.15)]',
        onClick && 'cursor-pointer hover:bg-[#EAEAFB] hover:text-[#8F8FEB]',
      )}
      onClick={onClick}
    >
      <ComputerIcon className="w-4 h-4 text-[#8F8FEB]" />
      {currentText}
    </Button>
  );
});

// 添加显示名称
DmLoadingBtn.displayName = 'DmLoadingBtn';
